// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  slotId: __t.u64().primaryKey().name("slot_id"),
  settlementId: __t.u64().name("settlement_id"),
  fn: __t.string(),
  recipeKey: __t.string().name("recipe_key"),
  wage: __t.i32(),
  minSkill: __t.f32().name("min_skill"),
  holderId: __t.u64().name("holder_id"),
  updatedAt: __t.timestamp().name("updated_at"),
});
